export class LoginHistoryState {
  userId: string;
  orgId: string;
}
